import React from 'react';
import { Button, Platform, StyleSheet, Text, View } from 'react-native';
import PropTypes from 'prop-types';

import { Theme } from '@constants';

export const MapDebugView = ({ frameNumberShown, maxFrames, frameNumberOverride, setFrameNumberOverride, fts, ts }) => (
  <View style={styles.base}>
    <Text style={styles.frameText}>{`Frame: ${frameNumberShown}/${maxFrames - 1}  Ts: ${ts}  Fts: ${fts}`}</Text>
    <View style={styles.buttonContainer}>
      <Button
        key={'Prev Frame'}
        style={styles.button}
        testID={'Previous'}
        title={'Prev Frame'}
        onPress={() => {
          if (frameNumberOverride > 0) {
            setFrameNumberOverride(frameNumberOverride - 1);
          }
        }}
      />
      <Button
        key={'Play/Pause'}
        style={styles.button}
        testID={'Play/Pause'}
        title={'Play/Pause'}
        onPress={() => {
          if (frameNumberOverride === null) {
            setFrameNumberOverride(frameNumberShown);
          } else {
            setFrameNumberOverride(null);
          }
        }}
      />
      <Button
        key={'Next Frame'}
        style={styles.button}
        testID={'Next'}
        title={'Next Frame'}
        onPress={() => {
          if (frameNumberOverride < maxFrames - 1) {
            setFrameNumberOverride(frameNumberOverride + 1);
          }
        }}
      />
    </View>
  </View>
);

MapDebugView.propTypes = {
  frameNumberShown: PropTypes.number,
  maxFrames: PropTypes.number.isRequired,
  frameNumberOverride: PropTypes.number,
  setFrameNumberOverride: PropTypes.func.isRequired,
  fts: PropTypes.number,
  ts: PropTypes.number,
};

MapDebugView.defaultProps = {
  frameNumberShown: null,
  frameNumberOverride: null,
  fts: null,
  ts: null,
};

const styles = StyleSheet.create({
  base: {
    backgroundColor: Theme.withOpacity(Theme.black, 0.3),
    borderRadius: Theme.px(4),
    bottom: Theme.px(50),
    flex: 1,
    justifyContent: 'center',
    left: Theme.px(100),
    padding: Theme.px(10),
    position: 'absolute',
    ...Platform.select({
      web: {
        gap: Theme.px(5),
      },
    }),
  },
  button: {
    borderRadius: Theme.px(4),
    height: Theme.px(35),
    width: Theme.px(200),
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    ...Platform.select({
      web: {
        gap: Theme.px(10),
      },
    }),
  },
  frameText: {
    flex: 1,
    textAlign: 'center',
  },
});
